module.exports = __webpack_public_path__ + "static/media/pencil.0e19fc8a.svg";